import React from "react";
import Icon from "components/Icon";
import { useIntl } from "react-intl";

const LoadingIndicator = ({ message }) => {
  const intl = useIntl();
  return (
    <div className="relative flex items-center space-x-2">
      {/* Rotating Loader */}
      <Icon name="loader20" size={20} className="animate-spin [animation-duration:2000ms]" />
      {/* Loading Text */}
      <span className="tw-button-text">{message || intl.formatMessage({ id: "activity.sendRequest" })}</span>
    </div>
  );
};

export default LoadingIndicator;
